<template>
  <div class="page-wrapper" id="page-wrapper" style="overflow-y: scroll; padding-bottom: 50px;">
    <v-container>
      <v-row>
        <v-col cols="10">
          <input type="date" class="form-control" v-model="date" @change="onDateChanged"/>
        </v-col>
        <v-col cols="2">
          <span class="form-control" v-on:click="onDateChanged"><i class="fas fa-sync"></i></span>
        </v-col>
      </v-row>
      <v-list dense v-if="orders.length > 0" class="pa-0">
        <v-card class="mb-2 pending-job" style="padding:10px;" v-for="order in orders" :key="'driver-order-' + order.id" v-bind:class="{'done-job':order.delivered == true, 'order-not-ready-yet': order.state < 18}">
          <v-row v-if="order.state < 18" >
            <v-col  col="12">
              <div  style="background: white; padding: 10px; color: red; font-weight: bold;">
                Picking Not confirmed yet
              </div>
            </v-col>
          </v-row>
          <v-row class="pa-1 pending-job" v-bind:class="{'done-job':order.delivered == true, 'order-not-ready-yet': order.state < 18}" no-gutters align="center"  v-on:click="getItem(order)">

            <v-col cols="6">
              <div class="h5">{{order.merchant.title}}</div>
              <div><i class="fas fa-map-marker"> </i> {{order.merchant.address}}</div>
              <div><i class="fas fa-phone"> </i> {{order.merchant.contact}}</div>
            </v-col>
            <v-col cols="6">
              <div class="h5 text-right">#{{order.id}}</div>
              <div class="h5 text-right" v-if="order.delivered == true">Done</div>
            </v-col>
          </v-row>
          <div style="display: none;">
            <v-row style="margin-top:10px;">
              <v-col cols="9" class="pt-0 pb-0"><strong>Items</strong></v-col>
              <v-col cols="3" class="pt-0 pb-0 text-center"><strong>Qty</strong></v-col>
            </v-row>
            <v-divider></v-divider>
            <template v-for="item in order.list">
              <v-row class="pa-1"  :key="'order-item-' + item.id">
                <v-col cols="9" class="pt-0 pb-0">
                  {{item.title}}
                </v-col>
                <v-col cols="3" class="pt-0 pb-0 text-center">
                  <input v-if="item.useVariablePrice == true" class="form-control" type="number">

                  </input>
                  <span v-else>
                    x{{item.amount}}
                  </span>
                </v-col>

              </v-row>
              <v-divider class="mt-1 mb-1"></v-divider>
            </template>
            <v-row v-if="order.delivered == false">
              <v-col cols="12" class="text-right">

                <button class="btn btn-primary" v-on:click="getItem(order)">Action</button>

              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" class="text-right">
                <div class="h5">Delivered</div>
                <div>at {{timeString(order.deliveredTime)}}</div>
                <div>Signed by {{order.signatureName}}</div>
              </v-col>
            </v-row>
          </div>

        </v-card>
      </v-list>


    </v-container>
    <div style="position: absolute; bottom:100px; right:20px; background-color: green; padding:10px;border-radius: 10px;color:white; box-shadow: 3px 3px 10px gray; font-weight: bold" v-on:click.stop="getCheckList"><span><i class="fas fa-list"></i></span> LIST</div>
    <transition name="slideup">
      <div v-if="selectedOrder !== false" style="z-index:3; position: absolute; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7);" v-on:click="closeItem">
        <div style="position: absolute; width: 90%; height: calc(100% - 150px); top:30px; left: 50%; transform: translateX(-50%); background-color: white; border-radius: 10px; overflow-y: scroll;" v-on:click.stop="dummy">
          <v-container>
  <!--          <v-card class="mb-2" :key="'driver-order-item-' + selectedOrder.id">-->
            <v-row  style="background-color: #0083FF; color:white; margin-top:-12px; margin-left:-12px; margin-right: -12px; padding:12px; vertical-align: top;" no-gutters align="center">
              <v-col cols="6">
                <div class="h5">{{selectedOrder.merchant.title}}</div>
                <div><i class="fas fa-map-marker"> </i> {{selectedOrder.merchant.address}}</div>
                <div><i class="fas fa-phone"> </i> {{selectedOrder.merchant.contact}}</div>
              </v-col>
              <v-col cols="6" style="vertical-align: top;">
                <div class="h5 text-right">#{{selectedOrder.id}}</div>
              </v-col>
            </v-row>
            <v-row style="margin-top:10px;">

              <v-col cols="9" class="pt-0 pb-0"><strong>Items</strong></v-col>
              <v-col cols="3" class="pt-0 pb-0 text-center"><strong>Qty</strong></v-col>
            </v-row>
            <v-divider></v-divider>
            <template v-for="(item, ii) in selectedOrder.list" v-if="item.state >= 0">
              <v-row class="pa-1" :key="'order-item-' + item.id + '-category-' + item.categoryId" v-if="ii === 0 || item.categoryTitle !== selectedOrder.list[ii-1].categoryTitle">
                <v-col cols="12" style="font-weight: bold; font-size: 20px;">{{item.categoryTitle}}</v-col>
              </v-row>
              <v-row class="pa-1" :key="'order-item-' + item.id" :class="{'not-ready-yet': item.state < 18}">
<!--                     v-on:click="changeAmount(item)"-->

                <v-col cols="2" class="pa-0 text-center" v-on:click.stop="onDriveItemChecked(item)">
                  <span style="font-size: 1.3rem;"><i class="fas fa-check unchecked" v-bind:class="{'fa-check-circle checked': item.driverChecked == true}"></i></span>
                </v-col>
                <v-col cols="7" class="pa-0">
                  {{item.title}}
                  <template v-if="item.notes.length > 0">
                    <div v-for="note in item.notes">
                      {{note.userName}}: {{note.description}}
                    </div>
                  </template>
                  <div v-if="item.useVariablePrice === true && item.variablePriceAmount >= 10000" style="font-weight: bold; font-size: 1.5rem; color:red;">
                    Check the weight!!!!
                  </div>
                </v-col>
                <v-col cols="3" class="pa-0 text-center" >
                  <template v-if="item.state > 0 && item.state < 18">
                    Not Ready
                  </template>
                  <template v-else>
                  <span>
                      x{{item.confirmedAmount}}
                  </span>
                  <br>

  <!--                <input  v-if="item.driverChecked == false" class="form-control text-center" type="number" v-model="item.variablePriceAmount" v-on:change="updateWeight(item)"/>-->
                  <span v-if="item.useVariablePrice === true" :class="{'warning-item': item.variablePriceAmount >= 10000}" style="font-weight: bold;">{{item.variablePriceAmountFloat.toFixed(2)}}Kg</span>

                  </template>
                </v-col>
              </v-row>
              <v-divider class="mt-1 mb-1"></v-divider>
            </template>
            <template v-if="selectedOrder.notes !== undefined && selectedOrder.notes.length > 0">
            <v-row >
              <v-col col="12" class="pt-0 bp-0" v-for="(note, index) in selectedOrder.notes" :key="'current-order-note-'+note.id">
                <strong>Memo{{index+1}}:</strong> {{note.description}}
              </v-col>
            </v-row>
            </template>
            <v-row  v-if="selectedOrder.state >= 18">
              <v-col col="12" class="pt-0 bp-0">
                <v-textarea auto-grow outlined
                            label="MEMO"

                            rows="2"
                            v-model="newNote"/>
              </v-col>
            </v-row>
            <v-row v-if="selectedOrder.state >= 18">
              <v-col col="12" class="pt-0 bp-0">
                <v-textarea auto-grow outlined
                            label="Signed By"

                            rows="1"
                            v-model="selectedOrder.signatureName"/>
              </v-col>

            </v-row>
            <v-row v-if="selectedOrder.state >= 18">
  <!--              <v-col cols="12" style="border: 1px solid grey;">-->
              <v-col cols="6">
                Signature
              </v-col>
              <v-col cols="6" class="text-right">
               <span class="float:right;" v-on:click.stop="undo">Clear</span>
              </v-col>
            </v-row>
            <v-row  v-if="selectedOrder.state >= 18">
              <v-col col="12" class="pt-0 bp-0">
                <VueSignaturePad
                  width="100%"
                  height="150px"
                  ref="signaturePad"
                  style="border:1px solid grey;"

                  :options="{ onBegin, onEnd, backgroundColor: 'rgb(255,255,255)' }"

                />
              </v-col>

  <!--              </v-col>-->

            </v-row>
            <v-row v-if="selectedOrder.state >= 18">
              <v-col cols="12">
                <progress style="width:100%;" value="0" max="100" id="uploader"></progress>
              </v-col>
            </v-row>


            <v-row style="position: sticky; bottom:0; background-color: white;">
              <v-col cols="6">
                <button class="btn btn-dark form-control" @click.stop="closeItem">CLOSE</button>
              </v-col>
              <v-col cols="6">
                <button class="btn btn-primary form-control" v-if="selectedOrder.state >= 18" @click.stop="save">COMPLETE</button>
                <span v-else style="color: red; font-weight: bold;">
                  Picking NOT Confirmed Yet!
                </span>
              </v-col>
            </v-row>

  <!--          </v-card>-->
          </v-container>

        </div>

      </div>
    </transition>
    <transition name="slideup">
      <div v-if="checkList != null && checkList.length > 0" style="z-index:3; position: absolute; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7);" v-on:click="closeCheckList">
        <div style="position: absolute; width: 90%; height: calc(100% - 150px); top:30px; left: 50%; transform: translateX(-50%); background-color: white; border-radius: 10px; overflow-y: scroll;" v-on:click.stop="dummy">

          <v-container>
            <template v-for="(item, ii) in checkList" v-if="checkList.length >= 0">
              <v-row class="pa-1" :key="'order-item-' + item.id + '-category-'+item.categoryId" v-if="ii === 0 || item.categoryTitle !== checkList[ii-1].categoryTitle">
                <v-col cols="12" style="font-weight: bold;">{{item.categoryTitle}}</v-col>
              </v-row>
              <v-row class="pa-1" :key="'order-item-' + item.id" :class="{'not-ready-yet': item.state < 18}"
<!--                     v-on:click="changeAmount(item)"-->
              >

                <v-col cols="2" class="pa-0 text-center" v-on:click.stop="onDriveItemChecked(item)">
                  <span style="font-size: 1.3rem;"><i class="fas fa-check unchecked" v-bind:class="{'fa-check-circle checked': item.driverChecked == true}"></i></span>
                </v-col>
                <v-col cols="7" class="pa-0">
                  <strong>{{getMerchantName(item.merchantId)}}</strong>
                  <br>
                  {{item.title}}
                  <template v-if="item.notes.length > 0">
                    <div v-for="note in item.notes" style="color:blue;">
                      {{note.userName}}: {{note.description}}
                    </div>
                  </template>
                  <div v-if="item.useVariablePrice === true && item.variablePriceAmount >= 10000" style="font-weight: bold; font-size: 1.5rem; color: red;">
                    Check the weight!!!!
                  </div>
                </v-col>
                <v-col cols="3" class="pa-0 text-center" >
                  <template v-if="item.state >= 0 && item.state < 18">
                    Not Ready
                  </template>
                  <template v-else>
                  <span>
                      x{{item.confirmedAmount}}
                  </span>
                  <br>

                  <!--                <input  v-if="item.driverChecked == false" class="form-control text-center" type="number" v-model="item.variablePriceAmount" v-on:change="updateWeight(item)"/>-->
                  <span v-if="item.useVariablePrice == true" :class="{'warning-item': item.variablePriceAmount >= 10000}">{{item.variablePriceAmountFloat.toFixed(2)}}Kg</span>
                  </template>

                </v-col>
              </v-row>
              <v-divider class="mt-1 mb-1"></v-divider>
            </template>

          </v-container>
          <v-container style="position: sticky; bottom:0; background-color: white;">
            <v-row>
              <v-col cols="12">
                <button class="form-control btn btn-dark" v-on:click="closeCheckList">Close</button>
              </v-col>

            </v-row>
          </v-container>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div v-if="changeAmountItem != false" style="z-index:3; position: absolute; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7);" v-on:click="closeChangeItem">
        <div style="position: absolute; width: 90%; height: calc(100% - 150px); top:30px; left: 50%; transform: translateX(-50%);  background-color: white; border-radius: 10px; overflow-y: scroll;" v-on:click.stop="dummy">
          <v-container>
            <v-row>
              <v-col>
                <h5>{{changeAmountItem.title}}</h5>
              </v-col>
            </v-row>
            <hr/>
            <v-row v-if="changeAmountItem.useVariablePrice == false">
              <v-col cols="12">
                Set Quantity
              </v-col>
              <v-col cols="4" class="text-center" v-on:click="changeAmountItemBy(-1)">
                <span style="height: 38px; line-height: 38px; font-size: 30px;"><i class="fas fa-minus-circle"></i></span>
              </v-col>
              <v-col cols="4" class="text-center">
                <input type="number" class="form-control text-center" v-model="changeAmountItem.amount" v-on:click="changeAmountItem.amount = ''"/>
              </v-col>
              <v-col cols="4" class="text-center" v-on:click="changeAmountItemBy(1)">
                <span style="height: 38px; line-height: 38px; font-size: 30px;"><i class="fas fa-plus-circle"></i></span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                Set Total Weight
              </v-col>
              <v-col cols="8">
                <input type="number" class="form-control text-right" v-model="changeAmountItem.variablePriceAmountFloat" v-on:click="changeAmountItem.variablePriceAmountFloat = ''"/>
              </v-col>
              <v-col cols="4" class="text-left">
                <span style="height: 38px; line-height: 38px;">KG</span>
              </v-col>
            </v-row>

            <v-row v-if="changeAmountItem.notes.length > 0">
              <v-col>
                Comments:
                <div v-for="note in changeAmountItem.notes">
                  {{note.userName}}: {{note.description}} <span v-if="note.userId == user.id" v-on:click="askRemoveNote(note)"><i class="fas fa-trash"></i></span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea auto-grow outlined
                            label="Comment"

                            rows="2"
                            v-model="changeAmountItem.note"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <button class="form-control btn btn-dark" v-on:click="closeChangeItem">Close</button>
              </v-col>
              <v-col cols="6">
                <button class="form-control btn btn-primary" v-on:click="submitChangeAmountItem">Update</button>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </transition>
    <v-dialog v-model="showNoteDeleteDialog">
      <v-card>
        <v-card-title>
          Delete Memo
        </v-card-title>
        <v-card-subtitle style="padding-top:20px;">
          Do you want to delete your memo "{{noteToDelete.description}}"
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="cancelRemoveNote">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="removeNoteConfirmed">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  import VueSignature from "vue-signature-pad";
  import * as firebase from "firebase/app";
  import "firebase/auth";
  import "firebase/storage";
  import moment from 'moment';
  import EventBus from "../api/event-bus";
  import {millisToDate, millisToHHMM, showDialog} from "../api/utils";
  import {
    deleteMemo,
    enterWeight, getDriverCategories,
    getDriverOrderItem,
    getDriverOrderList, getMerchants,
    updateDriverOrderChildItem,
    updateDriverOrderItem
  } from "../api/drivers";
  import {getUserByToken} from "../api/user";

    export default {
      name: "Driver",
      data() {
        return {
          date:'',
          user:false,
          orders:[],
          selectedOrder:false,
          signed: false,
          newNote:'',
          changeAmountItem:false,
          checkList:[],
          showNoteDeleteDialog: false,
          noteToDelete:false,
          merchants:[],
          categories:[],


        }
      },
      // components: {
      //   VueSignaturePad,
      // },
      created() {
        this.$data.date = millisToDate(new Date().getTime(), '-');
        console.log("Date " + this.$data.date );


      },
      mounted() {
        this.getMyInfo();
      },
      beforeDestroy() {
      },
      methods: {

        timeString: millisToHHMM,

        getMyInfo: function() {
          let self = this;
          getUserByToken()
          .then(function(data) {
            self.$data.user = data;
            self.getCategoryList();
          })
          .catch(function(err) {

          })
        },
        getCategoryList:function() {
          let self = this;
          getDriverCategories()
            .then(function(data) {
              if(data.success == true) {
                self.$data.categories = data.item;
                self.getList();
                self.getMerchantList();
              } else {
                showDialog(data.message, "No categories");
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
        },
        getList: function() {
          this.$data.checkList = [];
          this.$data.orders = [];
          if(this.$data.date === '' || this.$data.date === '0000-00-00') {
            return;
          }
          let self = this;
          getDriverOrderList(this.$data.date, true)
          .then(function(data) {
            if(data.success == true) {
              self.$data.orders = data.item;
            }
            EventBus.$emit("showLoading", false);
          })
        },
        onDateChanged: function() {
          this.getList();
        },
        dummy: function() {

        },
        closeItem: function() {
          this.$data.selectedOrder = false;
          this.$data.checkList = [];
        },
        getItem: function(order) {
          this.$data.checkList = [];
          if(order.delivered == true) {
            return;
          }
          let self = this;
          this.$data.signed = false;

          this.$data.newNote = '';
          getDriverOrderItem(order.id)
          .then(function(data) {
            if(data.success == true) {
              // let note = {
              //   id:0,
              //   orderId:data.item.id,
              //   description:'',
              // }
              // data.item.notes.push(note);
              console.log("Acquired item");
              console.log(data.item);
              for(let i = 0 ; i < data.item.list.length ; i++) {
                console.log(data.item.list[i] + ' ' + data.item.list[i].categoryCode);
              }
              data.item.list.sort(function(a, b) {
                let titleA = a.title;
                let titleB = b.title;
                if(titleA.includes('] ')) {
                  titleA = titleA.split('] ')[1];
                }
                if(titleB.includes('] ')) {
                  titleB = titleB.split('] ')[1];
                }
                if(titleA < titleB) {
                  return -1;
                } else if(titleA > titleB) {
                  return 1;
                }
                return 0;
                // return a.productId - b.productId;
              })
              data.item.list.sort(function(a, b) {
                if(a.categoryCode < b.categoryCode) {
                  return -1;
                }
                if(a.categoryCode > b.categoryCode) {
                  return 1;
                }
                return 0;
              })
              // data.item.list.sort(function (a, b){
              //   return a.categoryId - b.categoryId;
              // })
              // for(let i = 0 ; i < data.item.list.length ; i++) {
              //   if (data.item.list[i].useVariablePrice == true) {
              //     data.item.list[i].variablePriceAmount = (data.item.list[i].variablePriceAmount / 100.0).toFixed(2);
              //   }
              // }
              self.$data.selectedOrder = data.item;
              console.log(self.$data.selectedOrder);
              // document.getElementById('uploader').value=0;
            } else {
              showDialog("Failed");
            }
          })
          .catch(function(err) {
            console.log(err);
            showDialog("Error");
          })
        },
        updateWeight: function(item) {
          let self = this;
          console.log("update weight");
          console.log(item);
          let weight = parseInt(parseFloat(item.variablePriceAmount).toFixed(2).replace(".", ""));
          enterWeight(item.id, weight)
          .then(function(data) {
            if(data.success == true) {
              console.log(data);
              if(self.$data.selectedOrder != false && self.$data.selectedOrder.list != undefined) {
                for(let i = 0 ; i < self.$data.selectedOrder.list.length ; i++) {
                  if(self.$data.selectedOrder.list[i].id == data.item.id) {
                    // data.item.variablePriceAmount = (data.item.variablePriceAmount / 100.0).toFixed(2);
                    self.$data.selectedOrder.list.splice(i, 1, data.item);
                    return;
                  }
                }
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            console.log(err);
            showDialog(msg, "ERROR");
          })
        },
        onDriveItemChecked: function(item) {
          if(item.state >= 0 && item.state < 18) {
            showDialog("This item is not ready yet");
            return;
          }
          let self = this;
          if(item.useVariablePrice === true && item.driverChecked === false) {
            item.variablePriceAmount = Math.round(parseFloat(item.variablePriceAmountFloat)*100);
            if(item.variablePriceAmount > 10000) {
              showDialog("Weight cannot be greater than 100kg. Please adjust to correct weight");
              return;
            }
          }
          item.driverChecked = !item.driverChecked;
          updateDriverOrderChildItem(item)
          .then(function(data) {
            if(data.success == true) {
              if (self.$data.selectedOrder != false && self.$data.selectedOrder.id == data.item.parentId) {
                for (let i = 0; i < self.$data.selectedOrder.list.length; i++) {
                  if (self.$data.selectedOrder.list[i].id == data.item.id) {
                    // if (data.item.useVariablePrice == true) {
                    //   data.item.variablePriceAmount = (data.item.variablePriceAmount / 100.0).toFixed(2);
                    // }

                    self.$data.selectedOrder.list.splice(i, 1, data.item);
                  }

                  break;
                }
              }
              if (self.$data.checkList != null && self.$data.checkList.length > 0) {
                for (let i = 0 ; i < self.$data.checkList.length ; i++) {
                  if(self.$data.checkList[i].id == data.item.id) {
                    // if (data.item.useVariablePrice == true) {
                    //   data.item.variablePriceAmount = (data.item.variablePriceAmount / 100.0).toFixed(2);
                    // }
                    self.$data.checkList.splice(i, 1, data.item);
                    break;
                  }
                }
              }

            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            console.log(err);
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
              console.log(err.response);
            }

            showDialog("Sorry could not process due to error " + msg, "ERROR");
          })
        },
        undo() {
          this.$refs.signaturePad.undoSignature();
          this.$data.signed = false;
        },
        save() {
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/jpeg');
          console.log(isEmpty);
          console.log(data);
          if(isEmpty) {
            showDialog("Signature is required");
            return;
          }
          let block = data.split(";");
          // Get the content type of the image
          let contentType = block[0].split(":")[1];// In this case "image/gif"
          let fileExt = contentType.split('/')[1];
          // get the real base64 content of the file
          let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

          // Convert it to a blob to upload
          let blob = this.b64toBlob(realData, contentType);
          let d = new Date();
          let name = moment(d).format('YYYYMMDD-hhmmss') + '.' + fileExt;
          let path = 'delivery-signature/' + this.$data.selectedOrder.id + '-' + name;
          let storageRef = firebase.storage().ref();
          let mountainsRef = storageRef.child(path);
          let self = this;
          const uploader = document.getElementById('uploader');
          EventBus.$emit("showLoading", true);
          mountainsRef.put(blob).on('state_changed',
            function progress(snapshot){

              let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
              console.log("percentage " + percentage);
              uploader.value = percentage;

            },
            function error(err){
              console.log(err);
              EventBus.$emit("showLoading", false);
            },
            function complete(){
              EventBus.$emit("showLoading", false);
              console.log('complete upload https://storage.googleapis.com/kokoro-294123.appspot.com/' + path);
              self.$data.selectedOrder.signatureUrl = 'https://storage.googleapis.com/kokoro-294123.appspot.com/' + path;
              console.log(self.$data.selectedOrder.signatureUrl);
              uploader.value = 0;
              self.updateItem();
            }
          );

        },
        b64toBlob: function(b64Data, contentType, sliceSize) {
          contentType = contentType || '';
          sliceSize = sliceSize || 512;

          var byteCharacters = atob(b64Data);
          var byteArrays = [];

          for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
          }

          var blob = new Blob(byteArrays, {type: contentType});
          return blob;
        },
        onBegin() {
          console.log('=== Begin ===');
        },
        onEnd() {
          console.log('=== End ===');
          this.$data.signed = true;
        },
        submitChangeAmountItem: function() {
          let self = this;
          let item = this.$data.changeAmountItem;

          if(item.useVariablePrice == true) {
            item.variablePriceAmount = Math.round(parseFloat(item.variablePriceAmountFloat)*100);
            console.log("VPA " + item.variablePriceAmount);
          } else {
            console.log("not variable price item");
          }
          if(item.variablePriceAmount >= 10000) {
            showDialog("Weight cannot be greater than 100Kg<br/>Please enter correct weight.");
            item.variablePriceAmount = 0;
            item.variablePriceAmountFloat = 0.00;
            return;

          }
          updateDriverOrderChildItem(item)
            .then(function(data) {
              if(data.success == true) {
                self.$data.changeAmountItem = false;
                if(self.$data.selectedOrder != false) {
                  for (let i = 0; i < self.$data.selectedOrder.list.length; i++) {
                    if (self.$data.selectedOrder.list[i].id == data.item.id) {
                      // if (data.item.useVariablePrice == true) {
                      //   data.item.variablePriceAmount = (data.item.variablePriceAmount / 100.0).toFixed(2);
                      // }
                      self.$data.selectedOrder.list.splice(i, 1, data.item);
                      break;
                    }
                  }
                }
                if(self.$data.checkList != null && self.$data.checkList.length > 0) {
                  if (self.$data.checkList != null && self.$data.checkList.length > 0) {
                    for (let i = 0 ; i < self.$data.checkList.length ; i++) {
                      if(self.$data.checkList[i].id == data.item.id) {
                        // if (data.item.useVariablePrice == true) {
                        //   data.item.variablePriceAmount = (data.item.variablePriceAmount / 100.0).toFixed(2);
                        // }
                        self.$data.checkList.splice(i, 1, data.item);
                        break;
                      }
                    }
                  }
                }
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              showDialog("Sorry could not process due to error", "ERROR");
            })
        },
        changeAmountItemBy: function(diff) {
          if(this.$data.changeAmountItem.amount == '') {
            this.$data.changeAmountItem.amount = 0;
          }
          this.$data.changeAmountItem.amount += diff;
          if(this.$data.changeAmountItem.amount < 0) {
            this.$data.changeAmountItem.amount = 0;
          }

        },
        closeChangeItem: function() {
          this.$data.changeAmountItem = false;
        },
        changeAmount: function(item) {
          console.log("not allowed");
          // showDialog("You cannot change the amount");

          if(item.useVariablePrice !== true) {
            return;
          }
          if(item.state >= 0 && item.state < 18) {
            showDialog("This item is not ready yet");
            return;
          }

          if(item.driverChecked) {
            showDialog("Please Uncheck this item to set amount / weight");
            return;
          }
          this.$data.changeAmountItem = JSON.parse(JSON.stringify(item));
        },
        submitChangeItem: function() {

        },
        updateItem: function() {
          if(this.$data.selectedOrder.signatureName === '' || this.$data.selectedOrder.signatureName.length == 0) {
            showDialog("Please enter the name of person who signs");
            return;
          }
          this.$data.selectedOrder.delivered = true;
          this.$data.selectedOrder.deliveredTime = new Date().getTime();


          // if(this.$data.selectedOrder.notes[0].description == null || this.$data.selectedOrder.notes[0].description.length == 0) {
          //   this.$data.selectedOrder.notes = [];
          // }

          if(this.$data.newNote !== null && this.$data.newNote.length > 0) {
            let note = {
              id:0,
              orderId:this.$data.selectedOrder.id,
              description:this.$data.newNote,
            }
            this.$data.selectedOrder.notes.push(note);
          }
          let self = this;
          let order = JSON.parse(JSON.stringify(this.$data.selectedOrder));
          order.list = [];
          updateDriverOrderItem(order)
          .then(function(data) {
            if(data.success == true) {
              for(let i = 0 ; i < self.$data.orders.length ; i++) {
                if(self.$data.orders[i].id == data.item.id) {
                  self.$data.orders.splice(i, 1, data.item);
                  break;
                }
              }
              self.$data.selectedOrder = false;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            showDialog("Failed to update job");
          })
        },
        closeCheckList: function() {
          this.$data.checkList = [];
        },
        getCheckList: function() {

          // console.log("get check list");
          this.$data.checkList = [];
          this.$data.orders = [];
          if(this.$data.date === '' || this.$data.date === '0000-00-00') {
            return;
          }
          let self = this;
          getDriverOrderList(this.$data.date, false)
          .then(function(data) {
            if(data.success == true) {
              EventBus.$emit("showLoading", false);
              // console.log("driver order list");
              // console.log(data);
              for(let i = 0 ; i < data.item.length ; i++) {
                console.log(data.item[i].title + " " + data.item[i].categoryCode);
              }
              // data.item.sort(function(a, b) {
              //   let titleA = a.title;
              //   let titleB = b.title;
              //   if(titleA.includes('] ')) {
              //     titleA = titleA.split('] ')[1];
              //   }
              //   if(titleB.includes('] ')) {
              //     titleB = titleB.split('] ')[1];
              //   }
              //   if(titleA < titleB) {
              //     return -1;
              //   } else if(titleA > titleB) {
              //     return 1;
              //   }
              //   return 0;
              //   // return a.productId - b.productId;
              // })
              // data.item.sort(function(a, b) {
              //   if(a.categoryCode < b.categoryCode) {
              //     return -1;
              //   }
              //   if(a.categoryCode > b.categoryCode) {
              //     return 1;
              //   }
              //   return 0;
              // })
              self.$data.orders = data.item;
              self.populateCheckList();

            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log("Error getting check list");
            console.log(err);
            if(err.response !== undefined) {
              console.log(err.response);
            }
          })

        },
        populateCheckList: function() {
          let list = [];
          for(let i = 0 ; i < this.$data.orders.length ; i++) {
            for(let j = 0 ; j < this.$data.orders[i].list.length ; j++) {
              // console.log("populate check list " + i + " " + j);
              // if (this.$data.orders[i].list[j].useVariablePrice == true) {
              //   this.$data.orders[i].list[j].variablePriceAmount = (this.$data.orders[i].list[j].variablePriceAmount / 100.0).toFixed(2);
              // }

              list.push(this.$data.orders[i].list[j]);
            }
          }

          list.sort(function(a, b) {
            let titleA = a.title;
            let titleB = b.title;
            if(titleA.includes('] ')) {
              titleA = titleA.split('] ')[1];
            }
            if(titleB.includes('] ')) {
              titleB = titleB.split('] ')[1];
            }
            if(titleA < titleB) {
              return -1;
            } else if(titleA > titleB) {
              return 1;
            }
            return 0;
            // return a.productId - b.productId;
          })
          list.sort(function(a, b) {
            if(a.categoryCode < b.categoryCode) {
              return -1;
            }
            if(a.categoryCode > b.categoryCode) {
              return 1;
            }
            return 0;
          })
          this.$data.checkList = list;
        },
        askRemoveNote: function(note) {
          let self = this;
          self.$data.noteToDelete = JSON.parse(JSON.stringify(note));
          self.$data.showNoteDeleteDialog = true;
          console.log("askRemoveNote");
          console.log(self.$data.noteToDelete);
          // this.$modal.show('dialog', {
          //   //title: '로그아웃',
          //   text: 'Delete this memo? "' + note.description + '"',
          //   buttons: [
          //     {
          //       title: 'No',
          //       handler: () => {
          //         self.$modal.hide('dialog');
          //
          //       }
          //     },
          //     {
          //       title: 'Yes Delete',
          //       handler: () => {
          //         self.$modal.hide('dialog');
          //         self.removeNoteConfirmed(note);
          //       }
          //     },
          //
          //   ]
          //
          // });
        },
        cancelRemoveNote: function() {
          this.$data.noteToDelete = false;
          this.$data.showNoteDeleteDialog = false;
        },
        removeNoteConfirmed: function() {
          let self = this;
          deleteMemo(this.$data.noteToDelete.id)
            .then(function(data) {
              self.$data.noteToDelete = false;
              self.$data.showNoteDeleteDialog = false;
              if(data.success) {
                if(self.$data.changeAmountItem != false) {
                  if (self.$data.changeAmountItem.notes.length > 0) {
                    for (let i = 0; i < self.$data.changeAmountItem.notes.length; i++) {
                      if (self.$data.changeAmountItem.notes[i].id == data.item.id) {
                        self.$data.changeAmountItem.notes.splice(i, 1);
                        break;
                      }
                    }


                  }

                }
                if(self.$data.selectedOrder != false){

                  if (self.$data.selectedOrder.notes.length > 0) {
                    for (let i = 0; i < self.$data.selectedOrder.notes.length; i++) {
                      if (self.$data.selectedOrder.notes[i].id == data.item.id) {
                        self.$data.selectedOrder.notes.splice(i, 1);
                        break;
                      }
                    }
                  }
                  if(self.$data.selectedOrder.list.length > 0) {
                    for(let i = 0 ; i < self.$data.selectedOrder.list.length ; i++) {
                      if(self.$data.selectedOrder.list[i].notes.length > 0) {
                        for(let j = 0 ; j < self.$data.selectedOrder.list[i].notes.length ; j++) {
                          if(self.$data.selectedOrder.list[i].notes[j].id == data.item.id) {
                            self.$data.selectedOrder.list[i].notes.splice(j, 1);
                            return;
                          }
                        }
                      }
                    }
                  }

                }
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            })
        },

        getMerchantList: function() {
          let self = this;
          this.$data.merchants = [];
          getMerchants()
          .then(function(data) {
            if(data.success == true) {
              self.$data.merchants = data.item;
            }
          })
          .catch(function(err) {

          })
        },
        getMerchantName:function(id) {
          if(this.$data.merchants.length == 0) {
            return 'unknown';
          }

          for(let i = 0 ; i < this.$data.merchants.length ; i++) {
            if(this.$data.merchants[i].id == id) {
              return this.$data.merchants[i].title;

            }
          }

          return id;
        }
      }
    }
</script>

<style scoped>
  .pending-job {
    background-color: #0083FF;
    color:white;

  }
.done-job {
  background-color: #F1F1F1;
  color:grey;
}
.order-not-ready-yet {
  background: #f7a70a;
  color: black;
}
  .unchecked {
    color: #D7D7D7;
  }
  .checked {
    color: blue;
  }

  .warning-item {
    font-weight: bold;
    color: red;
  }
  .not-ready-yet {
    background: #eee;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/Driver.vue